import { Tooltip, Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"

import {
  BOX_GRADIENTS,
  GRADE_LEVELS,
  GRADE_TEXTS,
  GRADE_TOOLTIPS,
  GradeDisplayProps,
} from "./utils"

export const GradeDisplay = ({ grade, hideLabel }: GradeDisplayProps) => {
  const level = GRADE_LEVELS[grade]

  return (
    <Tooltip
      className="w-[228px] rounded-[4px] bg-onSurface-900 p-1"
      content={
        <div>
          <Typography className="text-[12px] font-medium leading-[130%] text-surface">
            {GRADE_TOOLTIPS[grade].title}
          </Typography>
          <Typography className="text-[12px] font-normal leading-[130%] text-surface-200">
            {GRADE_TOOLTIPS[grade].subtitle}
          </Typography>
        </div>
      }
    >
      <div className="flex items-center gap-1">
        {!hideLabel && (
          <Typography variant="strongSmallBody" className="text-onSurface-600">
            {GRADE_TEXTS[grade]}
          </Typography>
        )}

        <div className="flex items-center gap-0.5">
          {[...Array(5)].map((_, i) => {
            const filled = i < level

            return (
              <div
                key={i}
                className={clsx(
                  "size-2.25 rounded-[4px] transition-all duration-300",
                  filled ? BOX_GRADIENTS[i] : "bg-[#CBD5E1]",
                )}
              />
            )
          })}
        </div>
      </div>
    </Tooltip>
  )
}
